/**
 * Shortens Simple Bundles select option labels for clearer UX.
 * Only updates visible text; option values stay unchanged for cart properties.
 */
(function () {
  const CONTAINER_SELECTOR = "#simple-bundles-io-options";

  const STRIP_PREFIXES = [
    "Beofit Organic Protein Shake",
    "Beofit Organic Pre-Workout",
    "Beofit",
  ];

  const escapeRegex = (string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const toTitleCase = (string) =>
    string.replace(/\b\w+/g, (word) => {
      const lower = word.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    });

  const simplifyLabel = (text) => {
    let result = text.trim();
    if (!result) return text;

    const prefixes = [...STRIP_PREFIXES].sort((a, b) => b.length - a.length);
    for (const prefix of prefixes) {
      result = result.replace(
        new RegExp(`^${escapeRegex(prefix)}\\s*`, "i"),
        "",
      );
    }

    result = result.trim();
    return result ? toTitleCase(result) : text.trim();
  };

  const processSelect = (select) => {
    Array.from(select.options).forEach((option) => {
      if (option.disabled || !option.value) return;

      const original =
        option.dataset.bundleLabelOriginal || option.textContent.trim();
      option.dataset.bundleLabelOriginal = original;
      option.textContent = simplifyLabel(original);
    });
  };

  const processContainer = (container) => {
    container.querySelectorAll("select").forEach(processSelect);
  };

  let containerObserver = null;

  const watchContainer = (container) => {
    processContainer(container);

    if (containerObserver) containerObserver.disconnect();

    containerObserver = new MutationObserver(() => {
      processContainer(container);
    });

    containerObserver.observe(container, {
      childList: true,
      subtree: true,
    });
  };

  const tryInit = () => {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return false;

    watchContainer(container);
    return true;
  };

  const waitForContainer = () => {
    if (tryInit()) return;

    const bodyObserver = new MutationObserver(() => {
      if (tryInit()) bodyObserver.disconnect();
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForContainer);
  } else {
    waitForContainer();
  }

  window.addEventListener("load", tryInit);
})();
